import axiosInstance from "./Services/Api";

const getUserdata = async (startDate, endDate) => {
    try {
      // Include startDate and endDate as query parameters
      const response = await axiosInstance.get('/api/getUserData', {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });

      let seriesData = [];
      if (response.data.status === 0 && window.location.hash !== '#/profile') {
        window.location.href = '/#/configuracoes';
      }
      if (response.data && response.data.chartData) {
        response.data.chartData.forEach((values) => {
          seriesData.push(Number(values.total));
        });
        return response.data;
      } else {
        console.warn("No or invalid chart data found in the API response.");
      }
  
    } catch (e) {
      if (e.response && e.response.status === 401) { // Check for response status
        window.localStorage.removeItem('token');
        window.location.reload();
      }
      console.error("Erro ao buscar dados do usuário:", e);
    }
  };


  export {
    getUserdata
  }